import { IconButton, TableCell, TableRow, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@common/Icon/Icon";
import { DATE_FORMAT } from "@constants";
import { AdjustmentDetails } from "./Details/AdjustmentDetails";
import { PaymentDetails } from "./Details/PaymentDetails";
import { ITransaction } from "./interface/ITransactionHistory";
import { format } from "date-fns";

interface IParams {
    expandedTransaction?: string;
    transaction: ITransaction;
    setExpandedTransaction(expandedTransaction?: string): void;
}

export const TransactionHistory = (props: IParams) => {
    const {
        expandedTransaction,
        transaction: { amount, dateTime, reference, totalBalance, transactionType, paymentCorrelationTransactionUuid },
        setExpandedTransaction,
    } = props;
    const { t } = useTranslation("common");

    const isExpanded = expandedTransaction === reference;

    let detailsComponent: JSX.Element | undefined;
    if (transactionType === "ADJUSTMENT" || transactionType === "REFUND") {
        detailsComponent = <AdjustmentDetails reference={reference} />;
    } else if (transactionType === "PAYMENT") {
        detailsComponent = <PaymentDetails paymentCorrelationTransactionUuid={paymentCorrelationTransactionUuid} />;
    }

    const onClick = () => {
        setExpandedTransaction(isExpanded ? undefined : reference);
    };

    return (
        <Fragment>
            <TableRow hover onClick={onClick}>
                <TableCell>
                    <Typography color="secondary" variant="small">
                        {format(new Date(dateTime), DATE_FORMAT)}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography color="secondary" variant="small">
                        {transactionType}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography color="secondary" variant="small">
                        {t("price", { price: amount })}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography color="secondary" variant="small">
                        {t("price", { price: totalBalance })}
                    </Typography>
                </TableCell>
                <TableCell padding="none" variant="body">
                    {Boolean(detailsComponent) && (
                        <IconButton aria-label={isExpanded ? "Close" : "Open"} color="secondary">
                            <Icon name={`arrow-${isExpanded ? "up" : "down"}`} />
                        </IconButton>
                    )}
                </TableCell>
            </TableRow>

            {isExpanded && detailsComponent}
        </Fragment>
    );
};
